import { BaseFollowSignalData } from "@shared/types";

export const FOLLOW_SIGNAL_DATA_KEYS: (keyof BaseFollowSignalData)[] = [
  "trade_exists",
  "allow_follow",
  "requires_update",
  "requires_cancel",
  "bot_trade_exists",
  "bot_allow_follow",
  "bot_requires_update",
  "bot_requires_cancel",
];

export const FOLLOW_SIGNAL_DATA_KEYS_SET: Set<keyof BaseFollowSignalData> =
  new Set(FOLLOW_SIGNAL_DATA_KEYS);
